module.exports = __webpack_public_path__ + "static/img/icon_time.7bf06d62.png";